import moment from "moment";
import modelBase from "../model-base.model";
import _ from "lodash";
import { formats as FORMATS } from "../../config/constants.js";
import modelBaseV2 from "../model-base-v2.model.js";
import loginModel from "../login.model.js";

var scheduleUploadModel = {

  reqParams: {
    userIDs: [],
    fromDate: '',
    toDate: '',
  },

  resetDownloadForm: function () {
    this.reqParams.userIDs = [];
    this.reqParams.fromDate = moment().add(1, 'day').format(FORMATS.apiDateFormat);
    this.reqParams.toDate = moment().add(1, 'day').format(FORMATS.apiDateFormat);
  },

  isDownloadFormEmpty: function () {
    let isEmpty = false;
    if (!this.reqParams.userIDs || this.reqParams.userIDs.length < 1) {
      isEmpty = true;
    } else if (!this.reqParams.fromDate || this.reqParams.fromDate.length < 1) {
      isEmpty = true;
    } else if (!this.reqParams.toDate || this.reqParams.toDate.length < 1) {
      isEmpty = true;
    }
    return isEmpty;
  },

  downloadTemplate: function (successCallBack, failureCallBack) {
    modelBase.postDownload(successCallBack, failureCallBack, '/api/schedule/template/download', { body: this.reqParams }, "schedule-template.xlsx");
  },

  downloadSimpleTemplate: function () {
    let filename = `SimpleTemplate_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
    let body = {
      storedProcedureCode: "38",
      params: [
        {
          code: "66",
          value: "ScheduleByRows^" + loginModel.credentials.country,
        }
      ],
      "excelSheetNames": [
        "UploadTemplate", "CodeMaster", "OnlineVisits", "UnassignedShopsFreqByUserBySite"
      ]
    };
    return modelBaseV2.postDownload('/api/retail/file/export/commontemplateremark', { body }, filename)
  },

  uploadTemplate: function (successCallBack, failureCallBack, formData) {
    modelBase.postDownload(successCallBack, failureCallBack, '/api/schedule/template/upload', { body: formData }, "schedule-upload-result.xlsx");
  },

  uploadSimpleTemplate: function (successCallBack, failureCallBack, formData) {
    modelBase.postDownload(successCallBack, failureCallBack, '/api/schedule/template/upload/byrow', { body: formData }, "schedule-simple-upload-result.xlsx");
  },

}

export default scheduleUploadModel;
